
import React, { useEffect, useRef, useState } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { printDto } from "../../../api/interfaces/Posts";
import { useLoader } from "../../../Loader/LoaderContext";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useToaster } from "../../../Toaster/Toaster";
import { getService, postService } from "../../../servce/ApisService";
import { API_ENDPOINTS } from "../../../api";
import moment from "moment";
import TeaxtArea from "../../Portals/posts/TeaxtArea";
import DynamicTextPopup from "../../Portals/Modals/dynamicTextPopup";
import DynamicSuccessPopup from "../../Portals/Modals/DynamicSuccessPopup";

function AddBannerAds() {
   const {
      register,
      handleSubmit,
      control,
      watch,
      setValue,
      clearErrors,
      reset,
      setError,
      formState: { errors, isValid, isSubmitting, touchedFields, isDirty },
      setFocus,
    } = useForm<printDto>({
      mode: "onChange",
    });
    const [searchParams] = useSearchParams();
    const userId = searchParams ? searchParams.get('appUserId') : null;
  const navigate=useNavigate()
    const { setLoading } = useLoader();
   const [isOpen,setOpen]=useState(false);
    const [isPopupOpen, setIsPopupOpen] = useState(false);
    const handleOpenPopup = () => setIsPopupOpen(true);
    const handleClosePopup = () => setIsPopupOpen(false);
   
    const [submittedData, setSubmittedData] = useState<printDto | null>(null);
    const onSubmit: SubmitHandler<printDto> = (data) => {
      if (!selectedFile && !submittedData?.fileDto?.documentUrl) {
        setError("fileDto", {
          type: "manual",
          message: "Uploading  file is required",
        });
        return;
      }
     setSubmittedData(data)
     handleOpenPopup();
    };
    const { showToast } = useToaster();
    const handleConfirm = async () => {
      handleClosePopup();
      setLoading(true);
      try {
        let response;
        let fileDto = selectedFile
        ? {
            name: selectedFile.name,
            type: selectedFile.type,
            base64Str: file,
            size:selectedFile.size
          }
        : submittedData?.fileDto
        let payload: any = {
          fileDto,
          caption:submittedData?.caption,
          notes:submittedData?.notes
        };
        if (userId) {
          payload.id = parseInt(userId, 10);
          payload.vendorId = localStorage.getItem("vendorId");
          response = await postService(API_ENDPOINTS.updateWebsiteAd, payload);
        } else {
          let url: any;
          
          response = await postService(API_ENDPOINTS.saveWebsiteAd, payload);
        }
  
        if (response.statusCode === 200) {
          setOpen(true)
          
         
          console.log("User added successfully", response.data);
        } else {
          console.error("Error saving user:", response.data);
        }
      } catch (error: any) {
        showToast(error?.response?.data?.message, "error", "");
        console.error("Error saving user:", error);
      } finally {
        setLoading(false);
      }
    };
    const closePopup=()=>{
      setOpen(false);
      navigate('/vendorDashboard/activateDashbord/bannerAds/')
    }
    const [formattedSize, setFormattedSize] = useState<string>("");
    const [selectedFile, setSelectedFile] = useState<File | null>(null);
    const fileInputRef = useRef<HTMLInputElement>(null);
    const [file, setFile] = useState<string | null>(null);
    const formatFileSize = (size: number): string => {
      const i = Math.floor(Math.log(size) / Math.log(1024));
      const sizes = ["Bytes", "KB", "MB", "GB", "TB"];
      return parseFloat((size / Math.pow(1024, i)).toFixed(2)) + " " + sizes[i];
    };
    const clearFile = () => {
      setFile(null);;
      setSelectedFile(null);
      setSubmittedData((prev)=> ({...prev,fileDto: {
        name: '',
        base64Str: '',
        type: '',
        documentUrl: '',
        
      }} as printDto));
      
    };
    
      const handleDrop = async (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
        if (e.dataTransfer.files && e.dataTransfer.files[0]) {
          await handleFileChange(e.dataTransfer.files[0]);
        }
      };
    
      const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.stopPropagation();
      };
    const handleFileChange = async (file:File) => {
      if (file) {
        const selectedFile = file
        console.log(selectedFile);
        const formattedSize = formatFileSize(selectedFile.size);
        setFormattedSize(formattedSize);
        setSelectedFile(selectedFile);
        // Convert the file to a Base64 string
        const preview = await convertToBase64(selectedFile);
        setFile(preview);
        if (!preview) {
          setError("fileDto", {
            type: "manual",
            message: "Image is required.",
          });
          return; // Stop form submission if no image is uploaded
        } else {
          clearErrors();
        }
      }
    };
  
    const handleFileInputClick = () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
        fileInputRef.current.click();
      }
    };
    const reUploadFile = () => {
      if (fileInputRef.current) {
        fileInputRef.current.value = "";
      }
      setTimeout(() => handleFileInputClick(), 1000);
    };
  
    const convertToBase64 = (file: File): Promise<string> => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result as string);
        reader.onerror = (error) => reject(error);
      });
    };
    
    
    const fetchVehicles = async () => {
      setLoading(true);
      try {
        const response = await getService(`${API_ENDPOINTS.getWebsiteAd}?id=${userId}`);
        setSubmittedData(response.data);
        reset({
          ...response.data, // Resetting other data from the response
          date:response.data.date ? moment(response.data.date, "DD/MM/YYYY").format("YYYY-MM-DD") : "",
        });
      } catch (error) {
        console.error("Error fetching vehicle data:", error);
      } finally {
        setLoading(false);
      }
    };
    useEffect(() => {
      if (userId) {
        fetchVehicles();
      }
    }, [userId]);
  
  const users=()=>{
      navigate("/vendorDashboard/activateDashbord/bannerAds");
  }
  const today = new Date().toISOString().split("T")[0];
   const handleDateClick = (e: React.MouseEvent<HTMLInputElement>) => {
      e.preventDefault(); // Prevent default click action if needed
      e.currentTarget.showPicker(); // Re-focus to trigger the date picker again
    };
    const isButtonDisabled = !isValid || (!selectedFile && !submittedData?.fileDto?.documentUrl);
  return (
    <div className="h-full py-5 w-full p-8 pb-12">
      <form onSubmit={handleSubmit(onSubmit)} className="w-full relative">
        <div className="flex items-center mt-2 cursor-pointer justify-between  mb-4">
          <div className="flex items-center cursor-pointer">
            <h2
              className="mr-2 text-gray-700 font-semibold text-2xl flex items-center"
              onClick={() => users()}
            >
              <span><img src='/images/back.svg' className="mr-2" /></span>
              Add Banner
            </h2>{" "}
            
          </div>
          
        </div>

        <div className="flex items-center mt-2 cursor-pointer justify-between">
          
        </div>

        <div className="">
          <div className="w-full flex gap-8">
            <div className="w-[100%] sm:grid grid-cols-1 sm:grid-cols-none md:grid-cols-1 lg:grid-cols-1 gap-4 bg-white  px-6  pt-6 scroolCls h-[75vh] overflow-y-scroll ">
              
            <div className="w-[65%]">
            <div className="grid grid-cols-1 gap-6">
               
               <TeaxtArea
                 label="Caption"
                
                 register={register("caption", {
                   required: "Caption is required",
                   minLength: {
                     value: 10,
                     message: "Caption must be at least 10 characters",
                   },
                   maxLength: {
                     value: 500,
                     message: "Caption must not exceed 500 characters",
                   },
                 })}
                 error={errors.caption}
                 placement="Enter the Caption"
                //  tooltipText="Description information"
               /> 
               <TeaxtArea
                 label="Notes"
                
                 register={register("notes", {
                  //  required: "Notes is required",
                   minLength: {
                     value: 10,
                     message: "Notes must be at least 10 characters",
                   },
                   maxLength: {
                     value: 1000,
                     message: "Notes must not exceed 1000 characters",
                   },
                 })}
                 error={errors.notes}
                 placement="Enter the notes"
               />                
               <div className="form-group mb-4 sm:mb-0">
                 <label className="mb-1 ml-1 font-semibold text-gray-700 text-sm">
                 Upload banner
                  
                 </label>
                 <div className="relative" onDragOver={handleDragOver}
       onDrop={handleDrop}>
                   {!file && !submittedData?.fileDto?.documentUrl && (
                     <div className="border-dashed border-2 border-gray-300 p-6 rounded-md text-center bg-[#FF56770A]">
                       <label className="cursor-pointer">
                         <div className="flex justify-center mb-2">
                           <input
                             type="file"
                             // required={isPublish ? true : false}
                             accept="image/*"
                             onChange={(e) =>
                               e.target.files && handleFileChange(e.target.files[0])
                             }
                             // onChange={handleFileChange}
                             ref={fileInputRef}
                             className=" hidden w-full text-sm text-slate-500 file:mr-4 file:py-2 file:px-4 file:rounded-full file:border-0 file:text-sm file:font-semibold file:bg-red-50 file:text-red-700 hover:file:bg-red-100"
                           />
                           <img src="/images/uploadImgIcon.svg" />
                         </div>
                         <p className="font-semibold text-sm">
                           <span className="text-[#B00A2B]">
                           Upload Advertisement
                           </span>{" "}
                           <span className="text-gray-700">
                             or drag and drop
                           </span>
                         </p>
                         <p className="text-xs text-gray-500 font-normal mt-2">
                           Formats: PNG, JPG up to 10MB
                         </p>
                       </label>
                     </div>
                   )}
                   {(file || submittedData?.fileDto?.documentUrl) && (
                     <div className="mt-1 border border-[#E7E7E7] p-4 flex items-center justify-between rounded">
                       <div className="flex items-center">
                         <img
                           src={
                             file
                               ? (file as string)
                               : selectedFile
                               ? URL.createObjectURL(selectedFile)
                               : submittedData?.fileDto?.documentUrl
                           }
                           alt="Preview"
                           className="max-w-xs w-[45px] h-[45px] mr-3"
                         />
                         <div>
                           <h2 className="text-[#0B0B0B] font-semibold text-xs">
                             {selectedFile?.name
                               ? selectedFile?.name
                               : submittedData?.fileDto?.name}
                           </h2>
                           <p className="text-[#6D6D6D] text-sm font-normal">
                             {formattedSize}
                           </p>
                         </div>
                       </div>
                       <div className="flex items-center cursor-pointer">
                         {/* Refresh image that triggers file input */}
                         <span className="relative w-[50%] cursor-pointer">
                           <img
                             onClick={() => fileInputRef.current?.click()}
                             // onClick={reUploadFile}
                             src="/images/refresh.svg"
                             alt="Refresh"
                             className="max-w-xs mr-3 cursor-pointer"
                           />
                           {/* Hidden file input (within the div but does not interfere with the delete image) */}
                           <input
                             type="file"
                             accept="image/*"
                             onChange={(e) =>
                               e.target.files && handleFileChange(e.target.files[0])
                             }
                             // onChange={handleFileChange}
                             ref={fileInputRef}
                             // className="hidden"
                             className="absolute top-0 left-0 w-full h-full hidden cursor-pointer"
                             // style={{ zIndex: 2 }}
                             onClick={(e) => e.stopPropagation()} // Prevent event from bubbling up to parent elements
                           />
                         </span>
                         <span className="w-[50%]">
                           <img
                             onClick={clearFile}
                             src="/images/delete.svg"
                             alt="Delete"
                             className="max-w-xs cursor-pointer"
                           />
                         </span>
                       </div>
                     </div>
                   )}
                   {errors.fileDto && (
                     <p className="text-[#B91C1C] text-normal mt-2">
                       {errors.fileDto.message}
                     </p>
                   )}
                 </div>
               </div>
               
             </div>
            </div>
            </div>
          
          </div>

          <div className="fixed-buttons-container px-4">
                 <div></div>
        <div>
         
        <button
            type="submit"
            className={`px-7 py-2 font-Inter text-white rounded font-bold text-base gradient-background ${
              isButtonDisabled
                ? "opacity-80"
                : ""
            }`}
            disabled={isButtonDisabled}
            
          >
              {userId ? 'Update' :'Submit'}
          </button>
        </div>
      </div>
        </div>
      </form>
      
      {isPopupOpen && (
         <DynamicTextPopup
         onClose={handleClosePopup}
         title={userId ? 'Confirm Update' :'Confirm Upload'}
         body={userId ? ' Are you sure you want to update this banner? ': "Are you sure you want to upload this banner? Once uploaded, it will be reviewed before going live."}
         confirmButtonName={userId ? 'Update Banner ' : 'Upload Banner' }
         closeButtonName="Cancel"
         onConfirm= {handleConfirm}
     />
      )}
      {
        isOpen &&
        <DynamicSuccessPopup
        onClose={closePopup}
        title={userId ? 'Banner Updated':'Banner Uploaded'}
        body={userId ? ' Your banner has been successfully updated.' :'Your banner has been successfully'}
        closeButtonName="Close"
      />
      
      }
    </div>
  );
}

export default AddBannerAds
